import {CurrencyCode, NonNegativeInt} from '@raison/types';
import CurrencyClass from '~/shared/legacy_models/Currency/Currency';

export const FIAT_CURRENCY_PRECISION = 2;

class FiatCurrency extends CurrencyClass {
    currency?: CurrencyCode;

    constructor(amount: number | string, decimals_assets?: NonNegativeInt, currency?: CurrencyCode) {
        super(amount, decimals_assets ?? (FIAT_CURRENCY_PRECISION as NonNegativeInt));
        this.transactionsDigits = FIAT_CURRENCY_PRECISION;
        this.currency = currency;
    }

    static type = 'fiat';
}

export default FiatCurrency;
